var help = {
	showed: false,
    init: function() {
        var self = this,
            $helpTrigger = $( '[data-help="trigger"]' ),
            helpClosed = self.getCookie( 'help-closed' );

        if ( $helpTrigger.length < 1 ) {
        	return;
        }

        $helpTrigger.on( 'click', function( e ) {
            e.preventDefault();

            if ( $( document.body ).hasClass( 'help-opened' ) ) {
                self.setCookie( 'help-closed', '1', 7 );
            }

            $( document.body ).toggleClass( 'help-opened' );
        } );

        $( window ).on( 'scroll', function() {
            if ( self.showed === true ) {
                return;
            }

            var scroll = $( window ).scrollTop();
            var documentHeight = $( document.body ).outerHeight() - $(window).height();

            var scrolledPercent = ( scroll / documentHeight * 100 ).toFixed( 0 );

            if ( scrolledPercent > 30 ) {
                $( document.body ).addClass( 'help-visible' );

                if ( helpClosed == '' ) {
                    $( document.body ).addClass( 'help-opened' );
                }
               
                self.showed = true;
            }
        } );
    },
    getCookie: function( cname ) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent( document.cookie );
        var ca = decodedCookie.split( ';' );
        for ( var i = 0; i < ca.length; i++ ) {
            var c = ca[ i ];
            while ( c.charAt( 0 ) == ' ' ) {
                c = c.substring( 1 );
            }
            if ( c.indexOf( name ) == 0 ) {
                return c.substring( name.length, c.length );
            }
        }
        return "";
    },
    setCookie: function( cname, cvalue, exdays ) {
        var d = new Date();
        d.setTime( d.getTime() + ( exdays * 24 * 60 * 60 * 1000 ) );
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}

export {
    help
};
